import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { DisputesService } from 'app/main/services/disputes.service';
import { UtilsService } from 'app/main/services/utils.service';
import * as moment from 'moment';
import { AlertComponentComponent } from '../../alert/alert-component/alert-component.component';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';
import { SelectProfessorComponent } from '../select-professor/select-professor.component';

export class Dispute {
  id: string;
  genericOptionType: string;
  genericOptionTypeToShow: string;
  type: string;
  typeToShow: string;
  updatesFacade: Array<DisputeUpdate>;
  lastUpdateFacade: DisputeUpdate;
  author: any;
  availabilityInDispute: any;
  availabilityRecipient: any;
  availabilitySender: any;
  creationDate: any;
  creationDateString: any;
  multipleVariationProposal: any;
  purchasedSalesPackage: any;
  recipient: any;
}

export class DisputeUpdate {
  id: string;
  creationDateString: string;
  text: string;
  creationDate: number;
  author: any;
  prevStatus: string;
  currStatus: string;
  prevStatusToShow: string;
  currStatusToShow: string;
  creationDateToShow: any;
}

@Component({
  selector: 'app-dispute',
  templateUrl: './dispute.component.html',
  styleUrls: ['./dispute.component.scss']
})
export class DisputeComponent implements OnInit {

  @Input() inputDispute: any;
  @Output() disputeToSave: any;
  @Output() disputeToClose: any;
  dispute: Dispute;
  userLogged: any;
  isNew: any;
  options: any[];
  formGroup: FormGroup;
  title: string;
  fromModal: boolean;
  isAdminOrOperator: boolean;
  showCloseDisputeButton: boolean;
  sendButton: string;
  showCommands: boolean;
  isProfessor: boolean;
  labelDescrizione: string;
  class: string;
  containerClass: string;
  newAvailabilities: any;
  oldAvailabilities: any;
  bestMatchResponse: any;
  showAll: boolean;

  oldProfessorBestMatchResponseItem: any;
  newProfessorBestMatchResponseItem: any;
  forceShowSelect: boolean;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public utilsService: UtilsService,
    private localAccountService: LocalAccountService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private disputesService: DisputesService,
    private changeDetectorRef: ChangeDetectorRef,
    private location: Location,
    private router: Router
  ) {
    this.disputeToSave = new EventEmitter<any>();
    this.disputeToClose = new EventEmitter<any>();
    this.options = [];
    this.labelDescrizione = 'Descrizione';
    this.forceShowSelect = false;
  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputDispute']) {
      this.inputDispute = changes['inputDispute'].currentValue;
    }
    if (changes['dispute']) {
      this.dispute = changes['dispute'].currentValue;
    }
    this.initialize();
  }

  async ngOnInit() {
    this.userLogged = await this.localAccountService.getAccount();
    const isAdmin = await this.localAccountService.isAdmin();
    const isOperator = await this.localAccountService.isOperator();
    this.isProfessor = await this.localAccountService.isProfessor();
    this.isAdminOrOperator = isAdmin || isOperator;
    await this.initialize();
  }

  async initialize() {
    if (this.data && this.data.title) {
      this.title = this.data.title;
    }
    if (this.data) {
      this.fromModal = true;
    } else {
      this.fromModal = false;
    }
    this.class = 'formContainer m-0 p-0 mat-card';
    this.containerClass = 'w-100-p p-0 m-0';
    if (this.fromModal) {
      if (this.data.dispute) {
        this.dispute = this.data.dispute;
      } else {
        if (this.data.action) {
          switch (this.data.action) {
            case 'singleAvailabilityProblemDispute':
              this.dispute = new Dispute();
              this.dispute.type = 'SINGLE_AVAILABILITY_PROBLEM';
              this.forceShowSelect = true;
              break;
            case 'changeProfessorDispute':
              this.dispute = new Dispute();
              this.dispute.type = 'CHANGE_PROFESSOR';
              this.forceShowSelect = true;
              break;
          }
        }
      }
    } else {
      this.dispute = this.inputDispute;
    }

    if (!this.dispute) {
      this.dispute = new Dispute();
    }

    // non può essere spostato
    await this.prepareBuildForm();

    if (this.dispute.type === 'SINGLE_VARIATION_PROPOSAL' || this.dispute.type === 'MULTIPLE_VARIATION_PROPOSAL') {
      this.title = 'Proposta Variazione';
      if (this.dispute.availabilitySender) {
        if (this.dispute.availabilitySender.date) {
          this.dispute.availabilitySender.dateFormat = moment(this.dispute.availabilitySender.date).format('LLLL');
        }
      }
      if (this.dispute.availabilityRecipient) {
        if (this.dispute.availabilityRecipient.date) {
          this.dispute.availabilityRecipient.dateFormat = moment(this.dispute.availabilityRecipient.date).format('LLLL');
        }
      }
    } else if (this.dispute.type === 'CHANGE_PROFESSOR') {
      this.title = 'Richiesta Cambio Docente';
      this.labelDescrizione = 'Motivazione';
      if (this.dispute.purchasedSalesPackage && this.dispute.purchasedSalesPackage.lastChangeProfessorEvent) {
        if (this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.bestMatchResponse) {
          this.bestMatchResponse = this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.bestMatchResponse;
          if (this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.newProfessor) {
            for (let x = 0; x < this.bestMatchResponse.list.length; x++) {
              const el = this.bestMatchResponse.list[x];
              if (this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.newProfessor.id === el.professor.id) {
                this.newAvailabilities = el.availability;
              }
            }
          }
          if (this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.oldProfessorBestMatchResponseItem) {
            this.oldAvailabilities = this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.oldProfessorBestMatchResponseItem.availability;
            console.log(this.oldAvailabilities);
          } else if (this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.oldBestMatchRequest) {
            this.oldAvailabilities = this.dispute.purchasedSalesPackage.lastChangeProfessorEvent.oldBestMatchRequest;
          }
        }
      }
    } else if (this.dispute.type === 'SINGLE_AVAILABILITY_PROBLEM') {
      if (this.isNew) {
        this.title = 'Apri Contestazione';
      }
      this.labelDescrizione = 'Messaggio';
    } else if (this.dispute.type === 'GENERIC') {
      if (this.isNew) {
        this.title = 'Nuova Segnalazione';
      }
    }
    if (!this.title) {
      this.title = this.dispute.typeToShow;
    }

    this.buildForm();

    this.showAll = true;
  }

  goBack() {
    if (this.router.navigated) {
      this.location.back(); // OK
    } else {
      if (this.isAdminOrOperator) {
        this.router.navigateByUrl('/administration-area/admin-disputes');
      } else {
        if (this.isProfessor) {
          switch (this.dispute.type) {
            case 'SINGLE_AVAILABILITY_PROBLEM':
            case 'CHANGE_PROFESSOR':
            case 'GENERIC':
              return this.router.navigateByUrl('/users-area/professor-disputes');
            case 'SINGLE_VARIATION_PROPOSAL':
            case 'MULTIPLE_VARIATION_PROPOSAL':
              return this.router.navigateByUrl('/users-area/professor-communications');
          }
        } else {
          switch (this.dispute.type) {
            case 'SINGLE_AVAILABILITY_PROBLEM':
            case 'CHANGE_PROFESSOR':
            case 'GENERIC':
              return this.router.navigateByUrl('/users-area/student-disputes');
            case 'SINGLE_VARIATION_PROPOSAL':
            case 'MULTIPLE_VARIATION_PROPOSAL':
              return this.router.navigateByUrl('/users-area/student-communications');
          }
        }
      }
    }


  }

  async acceptVariationProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler accettare la proposta di variazione?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              this.loaderService.showLoader();
              const body: any = {
                id: uuid
              };
              const res: any = await this.disputesService.acceptSingleVariation(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  showBestMatch(bestMatch) {
    const dialog = this.dialog.open(SelectProfessorComponent, {
      width: '60%',
      maxHeight: '80vh',
      panelClass: 'custom-panel-class',
      data: {
        isChangeProfessorProposal: true,
        studentBestMatchRequestId: bestMatch.studentBestMatchRequestId,
        disputeId: this.dispute.id,
        obj: bestMatch.list,
        subscriptionName: this.dispute.purchasedSalesPackage.subscription.subject.degreeCourse.name + ' - ' + this.dispute.purchasedSalesPackage.subscription.subject.name,
        subscriptionTypeToShow: this.dispute.typeToShow,
        color: this.dispute.purchasedSalesPackage.subscription.color
      }
    });
  }

  async studentAcceptChangeProfessorProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler accettare la proposta di variazione docente?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.newProposalAcceptChangeProfessor(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  async studentRefuseChangeProfessorProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler rifiutare la proposta di variazione docente?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.newProposalAcceptChangeProfessor(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  async acceptChangeProfessorProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler accettare la richiesta di cambio docente?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.checkProposalChangeProfessor(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.dispute = res.payload;
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  async refuseChangeProfessorProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler rifiutare la richiesta di cambio docente?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.refuseChangeProfessor(body).catch(err => { console.error(err); }).finally(() => { this.loaderService.hideLoader(); });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  async refuseVariationProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler rifiutare la proposta di variazione?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.refuseSingleVariation(body).catch(err => { console.error(err); }).finally(() => { this.loaderService.hideLoader(); });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  async acceptMultipleVariationProposal(uuid) {
    const confirmDialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        // tslint:disable-next-line:max-line-length
        title: 'Sei sicuro di voler accettare la richiesta di variazione multipla? Le disponibilit&agrave; precedentemente indicate che collidono con quelle richieste dal discente verranno sovrascritte',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              confirmDialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'warn',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.acceptMultipleVariation(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    confirmDialog.close();
                    this.goBack();
                  }
                }
              }

            }
          }
        ]
      }
    });
  }

  async checkProposalChangeProfessor(uuid) {
    const confirmDialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Le disponibilit&agrave; precedentemente indicate che collidono con quelle richieste dal discente verranno sovrascritte',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              confirmDialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'warn',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.acceptMultipleVariation(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    confirmDialog.close();
                    this.goBack();
                  }
                }
              }

            }
          }
        ]
      }
    });
  }

  async refuseMultipleVariationProposal(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler rifiutare la proposta di variazione multipla?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.refuseMultipleVariation(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  async acceptDisputaFromAgenda(uuid) {
    const calculatedCredit = this.dispute.purchasedSalesPackage.studentHourlyCost * this.dispute.availabilityInDispute.totalHours;
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: '<div class="mb-20" style="font-size:14pt">Accettando la contestazione le <b>' + this.dispute.availabilityInDispute.totalHours
          + ' ore</b> della disponibilit&agrave; non verranno considerate come "ore erogate" per il docente <b>'
          + this.dispute.purchasedSalesPackage.professor.surname + ' ' + this.dispute.purchasedSalesPackage.professor.name
          + '</b>,<br /> inoltre verrà creato un credito di <b>'
          + calculatedCredit + ' €</b> per il discente <b>' + this.dispute.author.surname + ' ' + this.dispute.author.name + '</b>.</div>',
        buttons: [
          {
            text: 'Conferma',
            color: 'primary',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.acceptDisputeFromAgenda(body).catch(err => { console.error(err); }).finally(() => {
                this.loaderService.hideLoader();
              });
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          },
          {
            text: 'Annulla',
            close: true,
            value: false,
            callback: () => {
            }
          }
        ]
      }
    });
  }

  async refuseDisputaFromAgenda(uuid) {
    const dialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'Sei sicuro di voler rifiutare la proposta di contestazione?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              dialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'accent',
            close: false,
            value: true,
            callback: async () => {
              const body: any = {
                id: uuid
              };
              this.loaderService.showLoader();
              const res: any = await this.disputesService.refuseDisputeFromAgenda(body).catch(err => { console.error(err); }).finally(() => this.loaderService.hideLoader());
              if (res) {
                if (res.ok) {
                  if (res.payload) {
                    dialog.close();
                    this.goBack();
                  }
                }
              }
            }
          }
        ]
      }
    });
  }

  buildForm() {
    const formGroupObj: any = {
      id: [this.isNew ? '' : this.dispute.id],
      text: ['', Validators.required]
    };
    let val;
    if (this.isNew) {
      if (this.dispute.genericOptionType) {
        val = this.dispute.genericOptionType;
      } else {
        val = this.options[0].value;
      }
      formGroupObj.genericDisputeOption = [val, [Validators.required]];
    } else {
      formGroupObj.genericDisputeOption = [{ value: this.dispute.typeToShow, disabled: true }];
    }
    this.formGroup = this.formBuilder.group(formGroupObj);
    if (this.dispute.type === 'CHANGE_PROFESSOR' || this.dispute.type === 'SINGLE_AVAILABILITY_PROBLEM') {
      this.formGroup.controls['genericDisputeOption'].disable();
    }
  }

  async prepareBuildForm() {
    this.loaderService.showLoader();
    this.isNew = !this.dispute.id ? true : false;
    this.sendButton = this.dispute.updatesFacade && this.dispute.updatesFacade.length > 0 ? 'Rispondi' : 'Invia';
    this.showCloseDisputeButton = this.isAdminOrOperator && this.dispute.updatesFacade && this.dispute.updatesFacade.length > 0;
    this.showCommands = !this.dispute.lastUpdateFacade || this.dispute.lastUpdateFacade.currStatus !== 'CLOSED';
    let fromPage;
    if (this.fromModal) {
      fromPage = this.data.fromPage;
    }
    const res: any = await this.disputesService.getGenericOptionTypes(fromPage).catch(err => {
      console.error(err);
    }).finally(() => {
      this.loaderService.hideLoader();
    });
    if (res) {
      if (res.ok) {
        this.options = res.payload;
      }
    }
  }

  checkUpdateIsMine(update) {
    return this.userLogged.id === update.author.id;
  }

  checkIfOpen() {
    if (this.dispute.lastUpdateFacade.currStatus === 'OPEN') {
      return true;
    } else {
      return false;
    }
  }


  checkIfAccepted() {
    if (this.dispute.lastUpdateFacade.currStatus === 'ACCEPTED') {
      return true;
    } else {
      return false;
    }
  }

  checkIfRefused() {
    if (this.dispute.lastUpdateFacade.currStatus === 'REFUSED') {
      return true;
    } else {
      return false;
    }
  }

  sendDispute() {
    if (this.fromModal) {
      const outputObj = this.formGroup.value;
      if (this.data.purchasedSalesPackageId) {
        outputObj.purchasedSalesPackageId = this.data.purchasedSalesPackageId;
      }
      this.data.closeModal(outputObj);
    } else {
      this.disputeToSave.emit(this.formGroup.value);
    }
  }

  closeDispute() {
    if (this.fromModal) {
      this.data.closeModal({
        closeDispute: true,
        dispute: this.formGroup.value
      });
    } else {
      const dialog = this.dialog.open(AlertComponentComponent, {
        width: '400px',
        maxHeight: '80vh',
        data: {
          innerHTML: true,
          title: 'Sei sicuro di voler rispondere e chiudere la disputa?',
          buttons: [
            {
              text: 'Annulla',
              color: 'default',
              close: true,
              value: false,
              callback: async () => {
                dialog.close();
              }
            },
            {
              text: 'Conferma',
              color: 'accent',
              close: false,
              value: true,
              callback: async () => {
                dialog.close();
                this.disputeToClose.emit(this.formGroup.value);
              }
            }
          ]
        }
      });

    }
  }
}
